import React from "react";

import { COPY } from "../i18n/storefrontCopy";
import { trackStorefront, useStorefrontLocale } from "../i18n/StorefrontLocale";
import "./LanguageToggle.css";

const OPTIONS = [
  { value: "zh", label: "中文", lang: "zh-CN" },
  { value: "en", label: "EN", lang: "en" },
];

/** "中文 / EN" switch for the header. Rendered on the storefront route only. */
const LanguageToggle = () => {
  const { lang, setLang } = useStorefrontLocale();

  const choose = (next) => {
    if (next === lang) return;
    trackStorefront("storefront_language_changed", { from: lang, to: next });
    setLang(next);
  };

  return (
    <div className="lang-toggle" role="group" aria-label={COPY[lang].nav.language}>
      {OPTIONS.map((option, i) => (
        <React.Fragment key={option.value}>
          {i > 0 && <span className="lang-toggle__sep" aria-hidden="true">/</span>}
          <button
            type="button"
            lang={option.lang}
            className={`lang-toggle__btn${lang === option.value ? " lang-toggle__btn--on" : ""}`}
            aria-pressed={lang === option.value}
            onClick={() => choose(option.value)}
          >
            {option.label}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageToggle;
